import React from 'react';

const FOMOSection: React.FC = () => {
  return (
    <section className="py-20 px-4 bg-red-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-8 text-red-800">
          한정 무료 공개
        </h2>
        
        <div className="bg-white border-l-4 border-red-500 p-8 rounded-lg shadow-lg">
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              <strong className="text-red-600">광고 없이 오직 입소문으로만</strong><br />
              이 페이지를 다시 찾기는 어렵습니다
            </p>
            
            <p>
              <strong className="text-red-600">AI 시스템 운영 비용으로</strong><br />
              무료 구독은 선착순 제한됩니다
            </p>
            
            <p className="text-xl font-bold text-red-700">
              지금이 마지막 기회일 수 있습니다
            </p>
          </div>
        </div>
        
        <div className="mt-8 flex justify-center items-center space-x-4 text-red-600">
          <div className="flex items-center">
            <span className="w-3 h-3 bg-red-500 rounded-full animate-pulse mr-2"></span>
            <span className="font-semibold">한정 무료 제공</span>
          </div>
          <div className="flex items-center">
            <span className="w-3 h-3 bg-red-500 rounded-full animate-pulse mr-2"></span>
            <span className="font-semibold">선착순 마감</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FOMOSection;
